//
// site-lang.js: helpers for determining the current languague site
//

function html() {
  return document.documentElement;
}

function is_en() { const l = html().lang; return lang === 'en' || lang === 'en-US'; }
function is_de() { return html().lang === 'de-DE'; }
function is_es() { return html().lang === 'es-ES'; }
function is_fr() { return html().lang === 'fr-FR'; }

function country_code() {
  if (!country_code.code) {
    if      (is_de()) { country_code.code = 'de'; }
    else if (is_es()) { country_code.code = 'es'; }
    else if (is_fr()) { country_code.code = 'fr'; }
    else              { country_code.code = 'en'; }
  }
  return country_code.code;
}

export {
  country_code,
  is_en,
  is_de,
  is_es,
  is_fr,
};

